import { Component, inject, Input } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { HelpTrafficModalComponent } from '../help-traffic-modal/help-traffic-modal.component';

@Component({
  selector: 'lib-incidence-button',
  templateUrl: './incidence-button.component.html',
  styleUrls: ['./incidence-button.component.scss'],
  imports: [IonIcon, IonButton, TranslateModule],
})
export class IncidenceButtonComponent {
  private readonly modalCtrl = inject(ModalController);

  @Input()
  reference = '';

  async showIncidenceModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      // TODO change when new model of incidents and message was implemented
      // component: IncidenceModalComponent,
      component: HelpTrafficModalComponent,
      componentProps: {
        // stop: this.freight.stops.find(
        //   (stop) => stop.id === this.freight.nextStopId
        // ),
        // freightId: this.freight.id,
        reference: this.reference,
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
